import { get } from 'lodash';
import { MenuItem } from '@material-ui/core';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Button from '@material-ui/core/Button';
import { FieldArrayInputProps } from '../../../owner-shares/components/physical-person-input';
import { Person } from '../../../../../../global/entities/Person';
import { createFieldArrayInputName } from '../../../../../../utils/field-array/create-field-array-input-name';
import { PersonFieldInput } from '../../../owner-shares/components/person-field-input';
import { RHFSelect } from '../../../../../../packages/react-hook-form/select';
import { RelationType } from '../../../../../../global/entities/BuyOrder';
import { RepresentativeLabel } from '../../representatives-utils';
import { useBuyProcessForm } from '../../../../buy-process-form-utils';
import { useDeleteBuyOrderRelation } from '../../../../../admin/buy-process/buy-order-edit/use-buy-order-edit';

export const RepresentativesBoardMemberFieldInput = ({
  fieldArrayName,
  field,
  index,
  totalNumOfRepresentatives,
  remove,
}: FieldArrayInputProps<Person>) => {
  const createName = (name: string) =>
    createFieldArrayInputName(fieldArrayName, index, name);

  const isDeletable = () =>
    totalNumOfRepresentatives && totalNumOfRepresentatives > 2;

  const { errors, control } = useFormContext();
  const { id } = useBuyProcessForm();
  const { handleRemoveRelation } = useDeleteBuyOrderRelation(
    id,
    get(field, 'relationId'),
  );

  return (
    <React.Fragment>
      <Controller
        as={<input hidden />}
        name={createName('relationId')}
        defaultValue={get(field, 'relationId') || ''}
        control={control}
      />

      <PersonFieldInput
        index={index}
        field={field}
        fieldArrayName={fieldArrayName}
        extraFieldValues={{
          relationType: RelationType.BoardMember,
        }}
      />

      <div
        style={{
          marginTop: 32,
          maxWidth: 260,
        }}
      >
        <RHFSelect
          fullWidth
          errors={errors}
          name={createName('relationType')}
          label="Funktion"
          control={control}
          defaultValue={get(field, 'relationType') || RelationType.None}
          required
          margin="dense"
        >
          <MenuItem value={RelationType.None}>Välj</MenuItem>
          <MenuItem value={RelationType.BoardMember}>
            {RepresentativeLabel[RelationType.BoardMember]}
          </MenuItem>
          <MenuItem value={RelationType.SubstituteBoardMember}>
            {RepresentativeLabel[RelationType.SubstituteBoardMember]}
          </MenuItem>
          <MenuItem value={RelationType.Chairman}>
            {RepresentativeLabel[RelationType.Chairman]}
          </MenuItem>
        </RHFSelect>
      </div>

      {isDeletable() && (
        <Button
          variant="text"
          size="small"
          onClick={() => {
            remove(index);
            handleRemoveRelation();
          }}
          style={{ alignSelf: 'flex-end', marginTop: '12px' }}
        >
          Radera
        </Button>
      )}
    </React.Fragment>
  );
};
